<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content" v-menu-permission="'list'">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div
              id="collapseOne"
              class="collapse show"
              aria-labelledby="headingOne"
              data-parent="#accordionFilter"
          >
            <!--            style="background-color: #333333"-->
            <div class="card-body">
              <div
                  id="tree-map"
                  style="width: auto; height: 1000px"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
// Author YuJiaBei
// Date 2022-01-20 14:22:00

import emCommonListMixin from "@/mixin/em/common/list";
import emApiMixin from "@/mixin/em/common/api";
import * as echarts from "echarts";

export default {
  name: "emSicEmrecREocTreeMap",
  mixins: [emCommonListMixin, emApiMixin],
  components: {},
  props: {
    title_text: {
      type: String,
      default: ""
    },
    title_sub_text: {
      type: String,
      default: ""
    },
    root_id: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      data: [],
      option: {},
      myChart: {},
      colorSet: [
        "#5470c6",
        "#91cc75",
        "#fac858",
        "#ee6666",
        "#73c0de",
        "#3ba272",
        "#fc8452",
        "#9a60b4",
        "#ea7ccc",
      ],
      timer: null,
      timerInterval: 6000,
      treePathInfo: {},
      nodeData: [],
      currentNode: {},
      leafDepth: 3
      // testData: [{
      //   name: 'a',
      //   value: [2, 2, 3],
      //   children: [{name: 'a1', value: 1}, {
      //     name: 'a2',
      //     value: 1,
      //     children: [{name: 'a21', value: [1, '你好', '我不好']}, {name: 'a22', value: 1}, {
      //       name: 'a23',
      //       value: [2, '怎么说呢', '我就不放大小了']
      //     }]
      //   }]
      // }
      //   , {name: 'b', value: [1, 'b2', 'b3'], children: [{name: 'b1', value: 1}, {name: 'b2', value: 1}]}
      //   , {name: 'c', value: [1, 'c2', 'c3']}]
    };
  },
  computed: {
    modelName() {
      return "emSicEmrecREocTreeMap";
    }
  },
  methods: {
    refreshDate() {
      this.$_emApiMixin_post(
          this.$_emApiMixin_entityBaseApi("emSicEafmREocEmrec") + "/treeMap", this.currentNode
      ).then((res) => {
        this.data = res.data;
        this.initNodeData()
        //重新渲染myChart
        this.myChart.setOption({
          series: [
            {
              data: this.data,
              // leafDepth: this.leafDepth
            },
          ]
        });
      });
    },
    createSeriesCommon() {
      return {
        type: 'treemap',
        label: {
          position: 'insideTopLeft',
          formatter: function (params) {
            let arr = [
              '{name|' + params.name + '}'
            ];
            //如果是计算属性，就显示值和状态
            params.nodeType === 'emrec' &&
            arr.push(
                '{hr|}',
                '{eocValue|$ ' +
                echarts.format.addCommas(params.value[0]) +
                '} {status|' + params.status === 1 ? '正常' : '异常' +
                    '}'
            )
            ;
            return arr.join('\n');
          },
          rich: {
            eocValue: {
              fontSize: 22,
              lineHeight: 30,
              color: 'yellow'
            },
            household: {
              fontSize: 14,
              color: '#fff'
            },
            status: {
              fontSize: 9,
              backgroundColor: 'rgba(0,0,0,0.3)',
              color: '#fff',
              borderRadius: 2,
              padding: [2, 4],
              lineHeight: 25,
              align: 'right'
            },
            name: {
              fontSize: 12,
              color: '#fff'
            },
            hr: {
              width: '100%',
              borderColor: 'rgba(255,255,255,0.2)',
              borderWidth: 0.5,
              height: 0,
              lineHeight: 10
            }
          }
        },
        itemStyle: {
          borderColor: 'black'
        },
        name: '柜体布置图',
        top: 80,
        data: this.data,
      };
    },
    /**
     * 初始化一个和echarts一样的nodeData，因为echarts没有开放接口，而点击面包屑时，又只能得到nodeIndex，所以想在数据刷新后，依然保持当前的面包屑画面，就需要自行从自己的nodeData中取出数据，并把该数据作为root传回后端来重新查询。
     */
    initNodeData() {
      if (this.data[0]) {
        this.nodeData = [{name: '工厂模型矩形树图'}]
        this.flatData(this.data[0])
      }
    },
    flatData(node) {
      if (node) {
        this.nodeData.push(node)
        if (node.children) {
          for (const child of node.children) {
            this.flatData(child)
          }
        }
      }
    }
  },
  mounted() {
    // // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(document.getElementById("tree-map"));
    this.myChart.showLoading();

    //START: echart-tree  设备监控
    this.$_emApiMixin_post(
        this.$_emApiMixin_entityBaseApi("emSicEafmREocEmrec") + "/treeMap", {}
    ).then((res) => {
      this.data = res.data;
      this.initNodeData()
      this.myChart.hideLoading();

      // this.myChart.setOption(this.createSeriesCommon());
      // 绘制图表
      this.myChart.setOption(this.option = {
        title: {
          text: this.title_text,
          subtext: this.title_sub_text,
          left: 'leafDepth'
        },
        series: [
          {
            name: '工厂模型矩形树图',
            type: 'treemap',
            visibleMin: 300,
            data: this.data,
            leafDepth: this.leafDepth,             //只往下显示2层，再深了需要点击进去看
            upperLabel: {show: true}, //显示上层的label
            levels: [
              {
                itemStyle: {
                  borderColor: '#555',
                  borderWidth: 4,
                  gapWidth: 4
                },
                // color: this.colorSet
              },
              {
                colorSaturation: [0.1, 0.9],
                itemStyle: {
                  borderColor: '#251242',
                  borderColorSaturation: 0.7,
                  gapWidth: 3,
                  borderWidth: 2
                },
                // color: this.colorSet
              },
              {
                colorSaturation: [0.2, 0.8],
                itemStyle: {
                  borderColor: '#851242',
                  borderColorSaturation: 0.6,
                  gapWidth: 2
                },
                // color: this.colorSet
              },
              {
                colorSaturation: [0.3, 0.7],
                // color: this.colorSet
              }
            ],
            label: {
              position: 'insideTopLeft',
              show: true,
              fontSize:16
            },
          }
        ]
      });
    })
    this.myChart.on('click', (params) => {
      this.currentNode = this.nodeData[params.treePathInfo[params.treePathInfo.length - 1].dataIndex]
    });

    //设置定时器
    this.timer = setInterval(this.refreshDate, this.timerInterval);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
}
</script>
